var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{class:_vm.parentNodeClass},[_c('b-col',[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"mr-auto"},[_vm._t("left-content")],2),_c('div',[_vm._t("right-content")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }